export default __webpack_public_path__ + "static/media/uncommon_entrepreneurs.00d98504.png";